// Small shared primitives for the redesigned Marketing workspace.
// Mirrors the mockup's design tokens: cards with an optional colored top
// "eyelash", teal uppercase eyebrows, semantic pills. Semantic colors:
// teal = good, amber = caution, rose = critical; blue/navy stay accents.

// Static class map so Tailwind sees every literal (no dynamic strings).
const LASH = {
  blue: 'border-t-[3px] border-t-bullogic-blue',
  teal: 'border-t-[3px] border-t-deep-teal',
  navy: 'border-t-[3px] border-t-navy',
  sky: 'border-t-[3px] border-t-sky-blue',
  rose: 'border-t-[3px] border-t-rose',
  amber: 'border-t-[3px] border-t-amber',
  none: '',
};

export function Card({ lash = 'none', className = '', children }) {
  return (
    <div className={`bg-white border border-line rounded-[8px] shadow-[0_1px_3px_rgba(2,10,40,0.06),0_1px_2px_rgba(2,10,40,0.04)] ${LASH[lash] || ''} ${className}`}>
      {children}
    </div>
  );
}

export function Eyebrow({ className = '', children }) {
  return (
    <div className={`text-deep-teal text-[10.5px] font-black tracking-[0.1em] uppercase ${className}`}>
      {children}
    </div>
  );
}

const PILL = {
  good: 'bg-deep-teal/10 text-deep-teal',
  warn: 'bg-amber/15 text-amber',
  crit: 'bg-rose/15 text-[#d63a54]',
  neutral: 'bg-chip text-navy',
};

export function Pill({ tone = 'neutral', className = '', children }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] font-black px-2.5 py-[3px] rounded-full ${PILL[tone] || PILL.neutral} ${className}`}>
      {children}
    </span>
  );
}

export function Dot({ color, className = '' }) {
  return (
    <span
      className={`inline-block w-2 h-2 rounded-full shrink-0 ${className}`}
      style={{ backgroundColor: color }}
    />
  );
}
